import { useContext } from 'react'
import { ToastContext } from '@vineyard/shared'

const VARIANT_STYLES = {
  success: {
    bg: 'bg-[#f0fdf4]/85',
    text: 'text-[#166534]',
    hover: 'hover:bg-[#166534]/10',
  },
  error: {
    bg: 'bg-[#fef2f2]/85',
    text: 'text-[#991b1b]',
    hover: 'hover:bg-[#991b1b]/10',
  },
  info: {
    bg: 'bg-[#f3f0ff]/85',
    text: 'text-[#6333ba]',
    hover: 'hover:bg-[#6333ba]/10',
  },
  warning: {
    bg: 'bg-[#fffbeb]/85',
    text: 'text-[#92400e]',
    hover: 'hover:bg-[#92400e]/10',
  },
}

const VARIANT_ICONS = {
  success: 'check_circle',
  error: 'error',
  info: 'info',
  warning: 'warning',
}

export default function ToastList() {
  const ctx = useContext(ToastContext)
  if (!ctx || ctx.toasts.length === 0) return null

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] flex flex-col items-center gap-3 pointer-events-none">
      {ctx.toasts.map((t) => {
        const s = VARIANT_STYLES[t.variant]
        return (
          <div
            key={t.id}
            className={`flex items-center justify-between gap-3 px-5 py-3.5 rounded-full backdrop-blur-md shadow-[0_12px_40px_rgba(29,28,23,0.08)] animate-slide-up pointer-events-auto w-full min-w-[280px] max-w-[400px] ${s.bg}`}
          >
            <div className="flex items-center gap-3">
              <span
                className={`material-symbols-outlined ${s.text}`}
                style={{ fontSize: '18px', fontVariationSettings: "'FILL' 1" }}
              >
                {VARIANT_ICONS[t.variant]}
              </span>
              <span className={`text-[14px] font-semibold tracking-tight ${s.text}`}>
                {t.message}
              </span>
            </div>
            <button
              onClick={() => ctx.dismiss(t.id)}
              className={`p-1 rounded-full transition-colors ${s.hover}`}
              aria-label="닫기"
            >
              <span className={`material-symbols-outlined text-[18px] opacity-60 ${s.text}`}>close</span>
            </button>
          </div>
        )
      })}
    </div>
  )
}
